import { useTranslation } from "react-i18next";
import { memo } from "react";

import { Typography } from "../typography";

import type { ISubtitleProps } from ".";

export const Subtitle = memo(function Subtitle(props: ISubtitleProps) {
  const { title, ...rest } = props;
  const { t } = useTranslation("form");

  return (
    <Typography variant={"formSectionHeader"} {...rest}>
      {`${t(title)}:`}
    </Typography>
  );
});
